export const initialState = {
    currentPhotoIndex: 0,
    photoShape: null,
    quickViewHotspot: null,
    quickViewModalOpen: false,
    showQuickViewSpinner: false,
};

export function quickViewModalReducer(state = initialState, action = {}) {
    switch (action.type) {
        case 'CLOSE_QUICKVIEW_MODAL': {
            return {
                ...state,
                quickViewHotspot: null,
                quickViewModalOpen: false,
            };
        }
        case 'OPEN_QUICKVIEW_MODAL': {
            return {
                ...state,
                quickViewHotspot: {
                    ...action.hotspot,
                },
                quickViewModalOpen: true,
            };
        }
        case 'SHOW_QUICKVIEW_SPINNER': {
            return {
                ...state,
                showQuickViewSpinner: true,
            };
        }
        case 'HIDE_QUICKVIEW_SPINNER': {
            return {
                ...state,
                showQuickViewSpinner: false,
            };
        }
        case 'SET_CURRENT_PHOTO_INDEX': {
            return {
                ...state,
                currentPhotoIndex: action.currentPhotoIndex,
            };
        }
        case 'SET_PHOTO_SHAPE': {
            return {
                ...state,
                photoShape: action.photoShape,
            };
        }
        default:
            return state;
    }
}
